export default __webpack_public_path__ + "static/media/coupon-bg.11253e93.svg";